import { connect } from 'react-redux';
import { create as createUser } from '../redux/modules/auth';
import Signup from './signup';

export default connect(
  ({ auth: { user }, subscriptions, boligagents: { sessionPrefs } }) => ({
    user,
    sessionPrefs,
    subscription: Boolean(subscriptions.list.length)
  }),
  { createUser }
)(Signup);
